<template>
  <v-dialog v-model="dialog" max-width="90%" @keydown.esc="cancel" persistent>
    <v-card>
      <v-card-title v-show="!!title"
        ><span class="headline">{{ title }}の選択</span></v-card-title
      >
      <v-card-text>
        <datetime-picker
          :datetime="datetime"
          :disabled="readOnly"
          :selected-datetime.sync="datetime"
          :is-clear-when-init="true"
          :is-not-blank.sync="isNotBlank"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-2"
          color="primary"
          @click.native="agree"
          :disabled="!selectable"
        >
          選択
        </v-btn>
        <v-btn class="mx-2" color="primary" @click.native="cancel">
          キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import DatetimePicker from "@/components/DatetimePicker";

Vue.use(DatetimePicker);
export default {
  components: { DatetimePicker },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    datetime: null,
    beforeDatetime: null,
    readOnly: true,
    isNotBlank: { date: false, hour: false, minute: false },
    selectable: false
  }),
  watch: {
    isNotBlank: {
      handler: function(value) {
        // 日時をすべて選択、またはすべて未選択の場合のみ、選択ボタンを有効化する
        this.selectable = !!(
          (value.date && value.hour && value.minute) ||
          (!value.date && !value.hour && !value.minute)
        );
      },
      deep: true
    }
  },
  methods: {
    open(title, datetime, readOnly) {
      this.dialog = true;
      this.title = title;
      this.datetime = datetime;
      this.beforeDatetime = datetime;
      this.readOnly = readOnly;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(this.datetime);
      this.dialog = false;
    },
    cancel() {
      this.datetime = null;
      this.resolve(this.beforeDatetime);
      this.dialog = false;
    }
  }
};
</script>
